import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyMetadata, routeMetadata } from "../seo/metadata";

export default function RouteMetadata() {
  const { pathname } = useLocation();
  useLayoutEffect(() => { applyMetadata(routeMetadata(pathname)); }, [pathname]);
  return null;
}
